// @flow
import React from 'react';

import notification from 'antd/lib/notification';

import { vehicleMonitoringApi } from './../../../../../lib/api';
import type { VehicleMonitoring } from './../../../../../lib/types';

import Filter from './../../../../services/vehicleMonitoring/Filter';
import { VEHICLE_MONITORING_COLUMNS } from './../../../../services/vehicleMonitoring';

import { ListTable } from './../../../lib';
export default class extends ListTable<VehicleMonitoring> {
  fetch = async (page: number = 1) => {
    const params = super.fetch(page);
    try {
      const data = await vehicleMonitoringApi.fetchVehicleMonitorings(params);
      const totalSum = await vehicleMonitoringApi.getTotalSum(params);
      this.setState({ ...data, totalSum, loading: false, page });
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    }
  };

  render() {
    return (
      <>
        {super.renderFilter(Filter)}
        {super.renderTable(VEHICLE_MONITORING_COLUMNS)}
      </>
    );
  }
}
